<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Christopher Hayes-Brown is an accountant by profession, a wildlife conservationist at heart and subscribes to various animal charities along with helping to support cancer, arthritis, heart, and war veterans' charities. He loves gardening, and growing exotic plants, has various pets, enjoys writing and loves music, cinema and theatre. He has a fascination for ancient history, human cultures, traditions, religions and beliefs. He is a student of Lau Gar Kung Fu and interested in all forms of the martial arts, fascinated too by evolution, green technologies and magic.</p><br/>
<p style="text-indent:0px;">“My view,” he says, “is to look after others as you would like to be looked after yourself, be a good custodian to all living things and the well-being of the planet.</p>
<p style="text-indent:0px;">“If my books can give others enjoyment, a laugh, hope, to be compassionate and caring towards others and our wonderful wildlife and habitats, then I am a happy man.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ab237fae